import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderAvatarService {
  avatarChange = false;

  @Output()
  update: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  updateAvatar(status: boolean) {
    this.avatarChange = status;
    this.update.emit(this.avatarChange);
  }
}
